import React, { useState } from 'react';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

const pompeyoCarrascoCaseStudy = '/landing/caseStudies/pompeyocarrasco.jpg';
const salfaCaseStudy = '/landing/caseStudies/salfa.jpg';
const pompeyologo = '/landing/clients/pompeyo.png';
const salfalogo = '/landing/clients/salfa.png';

const CaseStudyLanding = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      id: 'salfa',
      company: 'Salfa',
      companyLogo: salfalogo,
      image: salfaCaseStudy,
      quote:
        'La plataforma de Zeller nos ayuda a analizar y nutrir nuestro CRM, cosa de ir priorizando en base a la intención de compra de los clientes.',
      author: {
        name: 'Anita Rodríguez',
        position: 'Subgerente de Canales Digitales, Salfa',
      },
      backgroundColor: '#4f81bd',
      textColor: '#ffffff',
      caseStudyId: '2',
    },
    {
      id: 'pompeyo-carrasco',
      company: 'Pompeyo Carrasco',
      companyLogo: pompeyologo,
      image: pompeyoCarrascoCaseStudy,
      quote: 'Con Zeller, nuestra tasa de cierre creció en un 200%.',
      author: {
        name: 'Vicente Carrasco',
        position: 'Gerente de Marketing y Nuevos Negocios, Pompeyo Carrasco',
      },
      backgroundColor: '#4f81bd',
      textColor: '#ffffff',
      caseStudyId: '1',
    },
  ];

  const nextSlide = () => {
    const newIndex = (currentSlide + 1) % testimonials.length;
    setCurrentSlide(newIndex);
  };

  const prevSlide = () => {
    const newIndex = (currentSlide - 1 + testimonials.length) % testimonials.length;
    setCurrentSlide(newIndex);
  };

  const goToSlide = (index: number) => {
    if (index === currentSlide) return;
    setCurrentSlide(index);
  };

  const currentTestimonial = testimonials[currentSlide];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 'bold',
            color: '#2c3e50',
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Lo que dicen nuestros clientes sobre nosotros...
        </Typography>

        <Box sx={{ position: 'relative', overflow: 'hidden' }}>
          <Card
            sx={{
              backgroundColor: currentTestimonial.backgroundColor,
              color: currentTestimonial.textColor,
              borderRadius: 4,
              overflow: 'hidden',
              mb: 4,
            }}
          >
            <CardContent sx={{ p: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  minHeight: '600px',
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    backgroundImage: `url(${currentTestimonial.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: { xs: '300px', md: '600px' },
                    position: 'relative',
                  }}
                />
                <Box
                  sx={{
                    flex: 1,
                    p: { xs: 4, md: 6 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      mb: 4,
                      fontStyle: 'italic',
                      lineHeight: 1.6,
                      fontSize: { xs: '1.2rem', md: '1.5rem' },
                    }}
                  >
                    &ldquo;{currentTestimonial.quote}&rdquo;
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 4,
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {currentTestimonial.author.name}
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        {currentTestimonial.author.position}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => window.open(`/casos-de-exito/${currentTestimonial.caseStudyId}`, '_blank')}
                      sx={{
                        color: currentTestimonial.textColor,
                        borderColor: currentTestimonial.textColor,
                        '&:hover': {
                          backgroundColor: 'rgba(255,255,255,0.1)',
                          borderColor: currentTestimonial.textColor,
                        },
                      }}
                    >
                      Leer Caso de Éxito →
                    </Button>

                    <Box
                      component="img"
                      src={currentTestimonial.companyLogo}
                      alt={currentTestimonial.company}
                      sx={{
                        height: '50px',
                        width: 'auto',
                        maxWidth: '150px',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', gap: 1 }}>
            {testimonials.map((testimonial, index) => (
              <Box
                key={testimonial.id}
                onClick={() => goToSlide(index)}
                sx={{
                  width: index === currentSlide ? 24 : 12,
                  height: 12,
                  borderRadius: '6px',
                  backgroundColor: index === currentSlide ? '#4f81bd' : '#ccc',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover': {
                    backgroundColor: index === currentSlide ? '#4f81bd' : '#999',
                  },
                }}
              />
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              onClick={prevSlide}
              sx={{
                backgroundColor: '#f5f5f5',
                color: '#4f81bd',
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                  color: '#4f81bd',
                },
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <IconButton
              onClick={nextSlide}
              sx={{
                backgroundColor: '#f5f5f5',
                color: '#4f81bd',
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 6,
          }}
        >
          <Button
            variant="contained"
            onClick={() => window.open('/casos-de-exito', '_blank')}
            sx={{
              backgroundColor: '#4f81bd',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              px: 4,
              py: 1.5,
              borderRadius: 3,
              textTransform: 'none',
              boxShadow: '0 4px 15px rgba(79, 129, 189, 0.3)',
              '&:hover': {
                backgroundColor: '#3d6499',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(79, 129, 189, 0.4)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Ver todos los casos de éxito
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CaseStudyLanding;
